import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col, Alert, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import "./Common.css";

const LoginPopup = ({ show, handleClose }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0 });
  const [captchaInput, setCaptchaInput] = useState("");
  
  const navigate = useNavigate();

  const generateCaptcha = () => {
    setCaptcha({
      num1: Math.floor(Math.random() * 10) + 1,
      num2: Math.floor(Math.random() * 10) + 1
    });
    setCaptchaInput("");
  };

  useEffect(() => {
    if (show) {
      generateCaptcha();
      setUsername("");
      setPassword("");
      setError("");
      setShowPassword(false);
    }
  }, [show]);

  const isCaptchaValid = parseInt(captchaInput) === (captcha.num1 + captcha.num2);
  const isFormValid = username.trim() !== "" && password.trim() !== "" && isCaptchaValid;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    
    if (!username || !password) {
      setError("Please enter both username and password.");
      return;
    }

    if (!isCaptchaValid) {
      setError("Invalid Captcha.");
      return;
    }

    setLoading(true);
    try {
      const response = await API.login(username, password);
      if (response.success) {
        localStorage.setItem("adminToken", response.token);
        // Optional: Save user data if needed
        // localStorage.setItem("adminUser", JSON.stringify(response.user));
        
        // Clear form
        setUsername("");
        setPassword("");
        setCaptchaInput("");
        
        handleClose();
        navigate("/admin/dashboard");
      } else {
        setError(response.message || "Login failed. Please try again.");
        generateCaptcha();
      }
    } catch (err) {
      setError("An error occurred during login. Please try again.");
      generateCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="login-modal position-relative">
        {/* Close Button */}
        <button className="custom-close-btn" onClick={handleClose}>
          ×
        </button>

        {/* Top Images */}
        {/* <Row className="align-items-center mb-4">
          <Col xs={3} className="text-start">
            <img src="/images/Wada13.svg" alt="" className="top-icon" />
          </Col>

          <Col xs={6} className="text-center">
            <img src="/images/AMB.svg" alt="" className="center-logo-login" />
          </Col>

          <Col xs={3} className="text-end">
            <img src="/images/Nhm.svg" alt="" className="top-icon" />
          </Col>
        </Row> */}

        <h3 className="login-title text-center mt-4 mb-4">LOGIN</h3>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleLogin}>
          {/* Username */}
          <Form.Group className="mb-3">
            <Form.Label>User Name</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="Enter User Name" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          {/* Password */}
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control 
                type={showPassword ? "text" : "password"} 
                placeholder="Enter Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button 
                variant="outline-secondary" 
                onClick={() => setShowPassword(!showPassword)}
                style={{ borderLeft: 'none', borderColor: '#ced4da', background: '#fff' }}
              >
                <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"} style={{ color: '#6c757d' }}></i>
              </Button>
            </InputGroup>
          </Form.Group>

          {/* Captcha */}
          <Form.Group className="mb-4">
            <Form.Label>Captcha</Form.Label>

            <Row className="align-items-center">
              <Col xs={5}>
                <div className="captcha-box">{captcha.num1} + {captcha.num2} = ?</div>
              </Col>
              
              <Col xs={1} className="px-0 text-center">
                <Button 
                  variant="link" 
                  className="p-0 text-decoration-none shadow-none" 
                  onClick={generateCaptcha}
                  title="Refresh Captcha"
                >
                  <i className="bi bi-arrow-clockwise" style={{ fontSize: '1.3rem', color: '#6c757d' }}></i>
                </Button>
              </Col>

              <Col xs={6}>
                <Form.Control 
                  type="text" 
                  placeholder="Enter Captcha" 
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                />
              </Col>
            </Row>
          </Form.Group>

          <div className="d-grid">
            <Button 
              type="submit" 
              className="login-btn d-flex justify-content-center align-items-center"
              disabled={loading || !isFormValid}
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default LoginPopup;
